import { render } from "./SupplierPublicCompanyContactPageList.vue?vue&type=template&id=dec657d8&ts=true"
import script from "./SupplierPublicCompanyContactPageList.vue?vue&type=script&lang=ts"
export * from "./SupplierPublicCompanyContactPageList.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__